var React = require('react');

function EventInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 2h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1V1a1 1 0 1 1 2 0v1h8V1a1 1 0 0 1 2 0v1zM2 4v2h12V4H2z","fill":"currentColor","fillRule":"evenodd"}));
}

EventInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = EventInline;

EventInline.default = EventInline;
